/**
 * Creates a debounced version of func, which is called
 * after timeout milliseconds.  If the functon is called
 * again before that timeout, the timeout is reset.
 */
export function debounce(func, timeout = 1) {
  let timer
  return (...args) => {
    clearTimeout(timer)
    timer = setTimeout(() => {
      func.apply(this, args)
    }, timeout)
  }
}
